module.exports = __webpack_public_path__ + "static/media/iamthatiam.b82a817b.jpg";